// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconLinearBox = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '24',
      height: '24',
      viewBox: '0 0 16 17',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2.11328 5.45996L7.99995 8.86663L13.8466 5.47996',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8 14.9068V8.86011',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.61993 2.15336L3.05993 4.12669C2.25326 4.57336 1.59326 5.69336 1.59326 6.61336V10.38C1.59326 11.3 2.25326 12.42 3.05993 12.8667L6.61993 14.8467C7.37993 15.2667 8.62659 15.2667 9.3866 14.8467L12.9466 12.8667C13.7533 12.42 14.4133 11.3 14.4133 10.38V6.61336C14.4133 5.69336 13.7533 4.57336 12.9466 4.12669L9.3866 2.14669C8.61993 1.72669 7.37993 1.72669 6.61993 2.15336Z',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
  );

export { IconLinearBox };
